import React from 'react';
import PropTypes from 'prop-types'
import '../../ReassignQueuePage.scss'
import HrbTranslate from '../../../../components/language/HrbTranslate';
import EmdashText from '../../../../components/library/common/EmdashText';
import { hasValue } from '../../../../services/util/CommonUtil';

const ReassignAssociateTableRow = ({ employee, handleRowSelect }) => {

    const handleRadioSelect = () => {
        handleRowSelect(employee.id, employee.firstName, employee.lastName);
    };

    return (
        <div className='columns reassign-associate-table-row'>
            <div className='column is-1 reassign-associate-radio-button-wrapper'>
                <input type='radio' name='selectedRow' className='reassign-associate-radio-button' onChange={handleRadioSelect} />
            </div>
            <div className='column is-2'>
                <p>{employee.firstName + ' ' + employee.lastName}</p>
            </div>
            <div className='column is-3'>
                <p>{employee.primaryJobTitle}</p>
            </div>
            <div className='column is-2'>
                <p>{employee.new}</p>
            </div>
            <div className='column is-2'>
                <p>{employee.inProgress}</p>
            </div>
            
            <div className='column is-2'>
                {!hasValue(employee.averageFileTime) ?
                    <EmdashText /> :
                    <HrbTranslate text={`Common.${employee.averageFileTime === 1 ? 'Day' : 'Days'}`}
                        params={{ Days: employee.averageFileTime }} />
                }
            </div>
        </div >
    );
}

ReassignAssociateTableRow.propTypes = {
    employee: PropTypes.object,
    handleRowSelect: PropTypes.func.isRequired,
}

export default ReassignAssociateTableRow